import { AlpineComponent } from '@alpinejs/csp';

const Search = (): AlpineComponent => ({
  isVisible: false,
  searchValue: '',
  init() {
    this.searchValue = this.$root.dataset.value;
  },
  toggleFilter() {
    this.isVisible = !this.isVisible;
  }
});

export default Search;
